(() => {
  const channelName = 'velora-cart-state';
  const storageKey = 'velora-cart-state-updated';
  const senderId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const initialData = document.getElementById('VeloraInitialCartData');
  let cart = { item_count: 0, items: [] };
  let refreshPromise = null;
  let queuedRefresh = null;
  let requestSequence = 0;
  let lastExternalTimestamp = 0;

  try {
    if (initialData?.textContent) cart = JSON.parse(initialData.textContent);
  } catch (error) {
    console.warn('Velora: no se pudo leer el carrito inicial.', error);
  }

  const channel = 'BroadcastChannel' in window ? new BroadcastChannel(channelName) : null;

  const getQuantity = (variantId) =>
    (cart.items || [])
      .filter((item) => String(item.variant_id || item.id) === String(variantId))
      .reduce((total, item) => total + Number(item.quantity || 0), 0);

  const updateHeaderCount = () => {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');
    const count = Number(cart.item_count || 0);

    if (count === 0) {
      bubble?.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartIcon.appendChild(bubble);
    }

    const visibleCount = bubble.querySelector('[aria-hidden="true"]');
    const accessibleCount = bubble.querySelector('.visually-hidden');
    if (visibleCount) visibleCount.textContent = count < 100 ? String(count) : '';
    if (accessibleCount) accessibleCount.textContent = `${count} productos en el carrito`;
  };

  const emit = (source) => {
    updateHeaderCount();
    if (source === 'external-tab') {
      document.documentElement.dataset.veloraCartDrawerStale = 'true';
      document.querySelectorAll('cart-items').forEach((cartItems) => cartItems.onCartUpdate?.());
    }
    document.dispatchEvent(
      new CustomEvent('velora:cart-state', {
        detail: { cart, source, getQuantity },
      })
    );
  };

  const notifyOtherTabs = () => {
    const message = { type: 'cart-changed', senderId, timestamp: Date.now() };
    channel?.postMessage(message);
    try {
      localStorage.setItem(storageKey, JSON.stringify(message));
    } catch (error) {
      // BroadcastChannel remains available when storage is restricted.
    }
  };

  const refresh = ({ source = 'refresh', broadcast = false } = {}) => {
    if (refreshPromise) {
      queuedRefresh = {
        source,
        broadcast: Boolean(broadcast || queuedRefresh?.broadcast),
      };
      return refreshPromise.then(() => {
        if (!queuedRefresh) return cart;
        const nextRefresh = queuedRefresh;
        queuedRefresh = null;
        return refresh(nextRefresh);
      });
    }
    const sequence = ++requestSequence;

    refreshPromise = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        return response.json();
      })
      .then((nextCart) => {
        if (sequence !== requestSequence) return cart;
        cart = nextCart;
        emit(source);
        if (broadcast) notifyOtherTabs();
        return cart;
      })
      .catch((error) => {
        console.error('Velora: no se pudo sincronizar el carrito.', error);
        return cart;
      })
      .finally(() => {
        refreshPromise = null;
      });

    return refreshPromise;
  };

  const synchronizeFromCartUpdate = (event = {}) => {
    const nextCart = event.cartData;

    if (Array.isArray(nextCart?.items) && Number.isFinite(Number(nextCart.item_count))) {
      cart = nextCart;
      emit('cart-update');
      notifyOtherTabs();
      return Promise.resolve(cart);
    }

    return refresh({ source: 'cart-update', broadcast: true });
  };

  const receiveExternalUpdate = (message) => {
    if (!message || message.senderId === senderId || message.type !== 'cart-changed') return;
    if (Number(message.timestamp || 0) <= lastExternalTimestamp) return;
    lastExternalTimestamp = Number(message.timestamp || 0);
    refresh({ source: 'external-tab' });
  };

  channel?.addEventListener('message', ({ data }) => receiveExternalUpdate(data));
  window.addEventListener('storage', (event) => {
    if (event.key !== storageKey || !event.newValue) return;
    try {
      receiveExternalUpdate(JSON.parse(event.newValue));
    } catch (error) {
      // Ignore invalid messages from unrelated or older theme versions.
    }
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh({ source: 'pageshow' });
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh({ source: 'visibility' });
  });

  const start = () => {
    emit('initial');
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, synchronizeFromCartUpdate);
    }
  };

  window.VeloraCartState = {
    getCart: () => cart,
    getQuantity,
    refresh,
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
